var map = {
	"./AAVE.svg": 580,
	"./AAVEe.svg": 581,
	"./ADA.svg": 582,
	"./ADX.svg": 583,
	"./ALPACA.png": 584,
	"./ALPHA.png": 585,
	"./AMPL.png": 586,
	"./ANN.png": 587,
	"./ANY.png": 588,
	"./ARBITRUM.svg": 589,
	"./ATOM.png": 590,
	"./AURO.png": 591,
	"./AVALANCHE.svg": 592,
	"./AVAX.png": 593,
	"./AVAX.svg": 594,
	"./AXS.png": 595,
	"./BABY.svg": 596,
	"./BABYCAKE.svg": 597,
	"./BAKE.png": 598,
	"./BALL.png": 599,
	"./BANANA.svg": 600,
	"./BCH.svg": 601,
	"./BDO.png": 602,
	"./BDP.png": 603,
	"./BEAR.png": 604,
	"./BETA.svg": 605,
	"./BETH.png": 606,
	"./BETU.png": 607,
	"./BHC.png": 608,
	"./BIFI.png": 609,
	"./BISON.png": 610,
	"./BITADA.png": 611,
	"./BITATOM.png": 612,
	"./BITBTC.png": 613,
	"./BITDOT.png": 614,
	"./BITSHARE.png": 615,
	"./BLZZ.svg": 616,
	"./BMON.svg": 617,
	"./BNB.png": 618,
	"./BOMB.png": 619,
	"./BONE.png": 620,
	"./BONEswap.png": 621,
	"./BOO.png": 622,
	"./BORING.png": 623,
	"./BP.png": 624,
	"./BREW.png": 625,
	"./BSC.svg": 626,
	"./BSCDEFI.svg": 627,
	"./BSCPAD.png": 628,
	"./BSHARE.png": 629,
	"./BTC.svg": 630,
	"./BTCB.svg": 631,
	"./BTD.png": 632,
	"./BTS.png": 633,
	"./BTT.png": 634,
	"./BUNNY.png": 635,
	"./BURGER.png": 636,
	"./BUSD.svg": 637,
	"./BUSDe.svg": 638,
	"./BUSM.png": 639,
	"./CAKE.svg": 640,
	"./CAPS.svg": 641,
	"./CARROT.png": 642,
	"./CEEK.png": 643,
	"./CELO.svg": 644,
	"./CHESS.svg": 645,
	"./CRA.png": 646,
	"./CRO.svg": 647,
	"./CRONA.svg": 648,
	"./CRONOS.svg": 649,
	"./CRV.png": 650,
	"./CRYSTL.png": 651,
	"./CTK.png": 652,
	"./CYT.png": 653,
	"./CZBNB.png": 654,
	"./CZBOMB.png": 655,
	"./CZBUSD.png": 656,
	"./CZEMP.png": 657,
	"./CZF.png": 658,
	"./CZSHARES.png": 659,
	"./DAI.png": 660,
	"./DAI.svg": 661,
	"./DAIe.png": 662,
	"./DAR.svg": 663,
	"./DELIRIUM.png": 664,
	"./DEP.png": 665,
	"./DFYN.png": 666,
	"./DG.png": 667,
	"./DINO.png": 668,
	"./DIS.svg": 669,
	"./DKT.png": 670,
	"./DOGE.svg": 671,
	"./DOLA.png": 672,
	"./DOT.png": 673,
	"./DPI.png": 674,
	"./DRUGS.png": 675,
	"./DVI.svg": 676,
	"./ELK.png": 677,
	"./EMP.png": 678,
	"./EPS.png": 679,
	"./ETERNAL.png": 680,
	"./ETH.svg": 681,
	"./EURt.png": 682,
	"./EXP.svg": 683,
	"./EZ.png": 684,
	"./FANTOM.svg": 685,
	"./FET.png": 686,
	"./FFF.png": 687,
	"./FIL.svg": 688,
	"./FINN.png": 689,
	"./FISH.svg": 690,
	"./FOO.png": 691,
	"./FORM.svg": 692,
	"./FOX.png": 693,
	"./FRAX.svg": 694,
	"./FRUIT.png": 695,
	"./FTM.png": 696,
	"./FXS.png": 697,
	"./GEIST.svg": 698,
	"./GHST.png": 699,
	"./GNT.png": 700,
	"./GOLDCOIN.svg": 701,
	"./GUARD.svg": 702,
	"./HAI.png": 703,
	"./HARD.png": 704,
	"./HARMONY.svg": 705,
	"./HBTC.png": 706,
	"./HECO.svg": 707,
	"./HERO.png": 708,
	"./HONEY.png": 709,
	"./HONOR.png": 710,
	"./HOTCROSS.svg": 711,
	"./HPS.png": 712,
	"./HT.png": 713,
	"./HTB.svg": 714,
	"./HUSD.png": 715,
	"./ICA.svg": 716,
	"./ICE.png": 717,
	"./IF.svg": 718,
	"./INCH.png": 719,
	"./INJ.png": 720,
	"./INV.png": 721,
	"./IRON.png": 722,
	"./JETS.png": 723,
	"./JOE.png": 724,
	"./JRT.png": 725,
	"./JULD.png": 726,
	"./JUST.png": 727,
	"./KART.png": 728,
	"./KEBAB.png": 729,
	"./KRW.png": 730,
	"./LAND.svg": 731,
	"./LAZIO.png": 732,
	"./LINK.png": 733,
	"./LINKe.png": 734,
	"./LITHIUM.svg": 735,
	"./LONG.png": 736,
	"./LTC.svg": 737,
	"./LUNA.png": 738,
	"./MAI.png": 739,
	"./MANA.png": 740,
	"./MARSH.png": 741,
	"./MASK.svg": 742,
	"./MATIC.svg": 743,
	"./MCB.png": 744,
	"./MCRN.svg": 745,
	"./MDX.png": 746,
	"./MERL.svg": 747,
	"./METAHERO.svg": 748,
	"./MIM.png": 749,
	"./MOON.png": 750,
	"./MOONRIVER.svg": 751,
	"./MOVR.png": 752,
	"./MSC.png": 753,
	"./MSS.png": 754,
	"./MUST.png": 755,
	"./NAOS.png": 756,
	"./NEXO.png": 757,
	"./NFT.png": 758,
	"./NFTY.png": 759,
	"./NUGGET.svg": 760,
	"./NUTS.png": 761,
	"./NYA.png": 762,
	"./NYAC.png": 763,
	"./NYAS.png": 764,
	"./O3.png": 765,
	"./OASIS.svg": 766,
	"./OCP.png": 767,
	"./ONE.svg": 768,
	"./ONG.svg": 769,
	"./ONT.png": 770,
	"./OOE.svg": 771,
	"./ORBS.svg": 772,
	"./PACOCA.svg": 773,
	"./PAUTO.png": 774,
	"./PBNB.png": 775,
	"./PEAR.svg": 776,
	"./PERA.png": 777,
	"./PETS.png": 778,
	"./PHA.png": 779,
	"./PHUB.png": 780,
	"./PMATIC.png": 781,
	"./PMP.svg": 782,
	"./PNG.svg": 783,
	"./POLYGON.svg": 784,
	"./PORTO.png": 785,
	"./POTS.png": 786,
	"./PUP.png": 787,
	"./PolyDoge.png": 788,
	"./QBT.svg": 789,
	"./QI.png": 790,
	"./QUICK.png": 791,
	"./RABBIT.svg": 792,
	"./RAMP.png": 793,
	"./RELAY.png": 794,
	"./REVV.svg": 795,
	"./RIB.png": 796,
	"./ROUTE.png": 797,
	"./RPG.png": 798,
	"./SAGE.png": 799,
	"./SBDO.png": 800,
	"./SCREAM.png": 801,
	"./SFP.png": 802,
	"./SFUND.png": 803,
	"./SHADE.png": 804,
	"./SHIB.png": 805,
	"./SHIBX.png": 806,
	"./SING.png": 807,
	"./SISTA.svg": 808,
	"./SKILL.svg": 809,
	"./SMART.png": 810,
	"./SNX.png": 811,
	"./SOAK.png": 812,
	"./SOL.png": 813,
	"./SOLAR.png": 814,
	"./SPADE.png": 815,
	"./SPELL.png": 816,
	"./SPIRIT.png": 817,
	"./SPS.svg": 818,
	"./STARS.svg": 819,
	"./START.png": 820,
	"./STEAK.png": 821,
	"./STEEL.png": 822,
	"./SUMMIT.png": 823,
	"./SUSHI.png": 824,
	"./SUSHIe.png": 825,
	"./SWAMP.svg": 826,
	"./SX.png": 827,
	"./SXP.svg": 828,
	"./SYN.svg": 829,
	"./TAPE.svg": 830,
	"./TEL.png": 831,
	"./TENFI.png": 832,
	"./TETU.svg": 833,
	"./TIME.png": 834,
	"./TITAN.svg": 835,
	"./TLOS.svg": 836,
	"./TREEB.png": 837,
	"./TRX.png": 838,
	"./TUSD.png": 839,
	"./TYPH.png": 840,
	"./UFT.png": 841,
	"./UNI.png": 842,
	"./UNIe.png": 843,
	"./USDC.svg": 844,
	"./USDCe.svg": 845,
	"./USDO.png": 846,
	"./USDT.svg": 847,
	"./USDTe.svg": 848,
	"./UST.png": 849,
	"./VVS.svg": 850,
	"./WAN.svg": 851,
	"./WATCH.png": 852,
	"./WAULTx.svg": 853,
	"./WBNB.svg": 854,
	"./WBTC.svg": 855,
	"./WBTCe.svg": 856,
	"./WETH.svg": 857,
	"./WETHe.svg": 858,
	"./WEX.svg": 859,
	"./WEXpoly.png": 860,
	"./WIN.png": 861,
	"./WMATIC.svg": 862,
	"./WMATIC_DFYN.svg": 863,
	"./WOO.svg": 864,
	"./WOOFY.png": 865,
	"./WSG.svg": 866,
	"./WUSD.svg": 867,
	"./XAVA.png": 868,
	"./XRP.svg": 869,
	"./XTZ.png": 870,
	"./XVS.png": 871,
	"./XWG.png": 872,
	"./YAMP.svg": 873,
	"./YEL.svg": 874,
	"./YELD.png": 875,
	"./YFI.png": 876,
	"./YFIe.png": 877,
	"./YGG.png": 878,
	"./ZBTC.svg": 879,
	"./ZETH.svg": 880,
	"./ZOO.png": 881,
	"./aQI.png": 882,
	"./aROME.png": 883,
	"./anyMTLX.png": 884,
	"./bQI.png": 885,
	"./bscBUSD.svg": 886,
	"./cEUR.png": 887,
	"./cUSD.png": 888,
	"./cakeHARD.png": 889,
	"./cakeROOBEE.png": 890,
	"./cakeSTAX.png": 891,
	"./cakeTWT.png": 892,
	"./cakebROOBEE.png": 893,
	"./fUSD.png": 894,
	"./fUSDT.png": 895,
	"./fWINGS.svg": 896,
	"./ibBTC.svg": 897,
	"./jCHF.png": 898,
	"./jEUR.png": 899,
	"./jGBP.png": 900,
	"./miMatic.png": 901,
	"./pBREW.png": 902,
	"./pOPEN.webp": 903,
	"./pWINGS.png": 904,
	"./polyBUNNY.png": 905,
	"./polyWISE.png": 906,
	"./rUSD.svg": 907,
	"./renBTC.png": 908,
	"./renBTC.svg": 909,
	"./renDGB.svg": 910,
	"./renDOGE.png": 911,
	"./sALPACA.svg": 912,
	"./sSPELL.png": 913,
	"./wMEMO.png": 914,
	"./xMARK.png": 915,
	"./xYELD.svg": 916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;